module.exports = __webpack_public_path__ + "img/vd-love-letter.afbf5204.svg";